export type IconTypeValue =
    | 'material-community'
    | 'material-design'
    | 'antdesign'
    | 'feather'
    | 'ionicon'
    | 'font-awesome-5'

export type GlyphMap = Record<string, number>;

import MCI from 'react-native-vector-icons/glyphmaps/MaterialCommunityIcons.json';
import MI from 'react-native-vector-icons/glyphmaps/MaterialIcons.json';
import AD from 'react-native-vector-icons/glyphmaps/AntDesign.json';
import FE from 'react-native-vector-icons/glyphmaps/Feather.json';
import IO from 'react-native-vector-icons/glyphmaps/Ionicons.json';
import FA5Free from 'react-native-vector-icons/glyphmaps/FontAwesome5Free.json';
// If you later add separate FA5 Brands TTF, import its glyphmap and map it here.

export const ICON_FAMILIES: Record<IconTypeValue, string> = {
    'material-community': 'MaterialCommunityIcons',
    'material-design': 'MaterialIcons',
    'antdesign': 'AntDesign',
    'feather': 'Feather',
    'ionicon': 'Ionicons',
    'font-awesome-5': 'FontAwesome',
};

export const ICON_GLYPHMAPS: Record<IconTypeValue, GlyphMap> = {
    'material-community': MCI as GlyphMap,
    'material-design': MI as GlyphMap,
    'antdesign': AD as GlyphMap,
    'feather': FE as GlyphMap,
    'ionicon': IO as GlyphMap,
    'font-awesome-5': FA5Free as GlyphMap,
};
